<template>
  <div class="content">
    <div
      class="content2"
      v-if="row.connectedStatus === '在线' && row.camera !== null"
    >
      <div
        class="content-left"
        style="width: 38%"
      >
        <div class="content-left-top">
          <div style="font-size: 18px; display: flex; align-items: center">
            <img
              style="display: flex; align-items: flex-end; cursor: pointer"
              src="../../../assets/image/back.png"
              @click="$router.go(-1)"
              alt=""
            /><span style="
                width: 8vw;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              ">{{ towerName }}</span>
          </div>
          <div>
            <span
              class="button"
              style="margin-right: 1vw"
              @click="entDatas"
            >参数设置</span>
            <span
              class="button"
              @click="handleDelete"
            >删除</span>
          </div>
        </div>
        <div
          class="content-left-main"
          style="height: calc(100% - 50px); position: relative"
        >
          <div style="
              position: absolute;
              top: 16px;
              left: 16px;
              font-size: 14px;
              color: #909399;
              z-index: 1;
            ">
            <p style="font-size: 14px">塔身高度：{{ towerHeight || 0 }}m</p>
            <p style="font-size: 14px; margin-top: 10px">
              起重臂长：{{ towerArmLength || 0 }}m
            </p>
          </div>
          <div style="
              position: absolute;
              bottom: 72px;
              right: 12px;
              font-size: 14px;
              color: #909399;
              z-index: 1;
              text-align: left;
            ">
            <p style="font-size: 14px">
              吊钩高度：<span style="color: #fff">{{ valData.hight }}m</span>
            </p>
            <p style="margin-top: 14px; font-size: 14px">
              小车幅度：<span style="color: #fff">{{ valData.radius }}m</span>
            </p>
            <p style="margin-top: 14px; font-size: 14px">
              大臂回转：<span style="color: #fff">{{ valData.angle }}°</span>
            </p>
            <p style="margin-top: 14px; font-size: 14px">
              吊起重量：<span style="color: #fff">{{ valData.loadweightr }}T</span>
            </p>
            <p style="margin-top: 14px; font-size: 14px">
              起重力矩：<span style="color: #fff">{{ valData.lijupercent }}%</span>
            </p>
            <p style="margin-top: 14px; font-size: 14px">
              姿态倾角：<span style="color: #fff">{{ valData.fall }}°</span>
            </p>
            <p style="margin-top: 14px; font-size: 14px">
              塔顶风速：<span style="color: #fff">{{ valData.windspeed }}m/s</span>
            </p>
          </div>
          <div style="position: absolute; top: 17px; right: 17px; z-index: 1">
            <img
              :src="warn.icon"
              style="width: 5vh; position: relative"
            />
          </div>
          <div style="
              position: absolute;
              width: 100%;
              bottom: 24px;
              font-size: 14px;
              color: #909399;
              z-index: 1;
            ">
            更新时间：{{ allPart.updateDate }}
          </div>
          <iframe
            ref="mainIframe"
            style="width: 100%; height: 100%"
            src="/webgl-td"
          ></iframe>
          <!-- <div style="height: 180px;">
          <img src="../../../assets/image/tdjc.png" style="height: 100%">
        </div>
        <div class="content-left-1">
          <div>
            <p style="margin-bottom: 10px;">36m</p>
            <p>塔身高度</p>
          </div>
          <div>
            <p style="margin-bottom: 10px;">65m</p>
            <p>起重臂长</p>
          </div>
          <div>
            <p style="margin-bottom: 10px;">12m</p>
            <p>平衡臂长</p>
          </div>
        </div>
        <div class="content-left-2"> 
          <div>吊钩高度：{{valData.hight}}m</div>
          <div>小车幅度：{{valData.radius}}m</div>
          <div>大臂回转：{{valData.angle}}°</div>
          <div>吊起重量：{{valData.loadweightr}}T</div>
          <div>起重力矩：{{valData.lijupercent}}%</div>
          <div>姿态倾角：{{valData.fall}}°</div>
          <div>塔顶风速：{{valData.windspeed}}m/s</div>
          <p style="font-size: 14px;color: #909399;">更新时间：{{allPart.updateDate}}</p>
        </div> -->
        </div>
      </div>
      <div
        class="content-right"
        style="height: 88vh"
      >
        <div class="content-right-top">
          <div class="box2">
            <div class="box-title">大臂回转角度监测</div>
            <div class="box-cont">
              <div class="real-clock">
                <div
                  class="real-clock-con"
                  id="wrap"
                >
                  <ul id="list"></ul>
                  <div class="icon"></div>
                  <div
                    id="clockLine"
                    :style="{
                      '-webkit-transform': 'rotate(' + allPart.angle + 'deg)',
                    }"
                  ></div>
                  <div class="num0">0</div>
                  <div class="num90">90</div>
                  <div class="num180">180</div>
                  <div class="num270">270</div>
                </div>
              </div>
            </div>
            <p class="wenzi">当前角度</p>
          </div>
          <!-- <div class="box3">
          <div class="box-title">实时预警</div>
          <div class="box-cont">
            <div style="width:100%;height:100%;padding:1vh 1.5vw;display:flex;align-items: center;align-content: center;justify-content: center;justify-items: center;flex-wrap:wrap;overflow: hidden;margin-top:12%">
            <img :src="warn.icon" style="width: 23vh;position: relative;" />
            <template v-if="warn.list.length>0">
              <p v-for="(item,index) in warn.list" :key="index" style="width:100%;margin-top:1vh;color:red;">{{item}}</p>
            </template>
            <template v-else>
              <p style="width:100%;margin-top:1vh;">暂无预警</p>
            </template>
          </div>
          </div>
      </div> -->
          <div class="content-right-3">
            <p
              class="title"
              style="
                display: flex;
         
                align-items: center;
              "
            >
              <span>预警记录</span><span
                @click="toMore"
                class="button"
                style="margin-left: 9.0417vw;"
              >更多</span>
              <span
                @click="addShow"
                class="button"
                style="margin-left: .5208vw;"
              >设置</span>
            </p>
            <div style="
                height: 45vh;
                padding: 18px 8px;
                overflow: auto;
                padding-bottom: 0;
              ">
              <div
                class="record-list"
                v-for="(item, index) in warnList"
                :key="index"
              >
                <div style="display: flex; align-items: center">
                  <div style="
                      margin-right: 3px;
                      width: 3vh;
                      height: 3vh;
                      position: relative;
                      background: #fff;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <img
                      :src="httpCtx + item.icon"
                      style="max-width: 3vh; max-height: 3vh"
                    />
                  </div>
                  <span style="font-size: 14px">{{ item.typeName }}</span>
                </div>
                <div style="font-size: 14px">
                  {{ item.value }} {{ item.unit }}
                </div>
                <div style="font-size: 14px">{{ item.createDate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="video">
          <!-- <div class="video"> -->
          <div
            class="btn"
            id="btn"
            @click="enterDg"
          >操作</div>
          <div
            id="video-container"
            style="width: 99%"
            class="box-video"
          ></div>
        </div>
        <div class="content-right-bottom">
          <!-- <div class="content-right-3">
          <p class="title" style="display: flex;justify-content: space-between;align-items: center;"><span>预警记录</span><span @click="toMore" class="button">更多</span></p>
          <div style="height: 27.2vh;padding: 18px 8px;overflow: auto;padding-bottom:0">
            <div class="record-list" v-for="(item,index) in warnList" :key="index">
              <div style="display:flex;align-items: center;">
                <div style="margin-right:3px;width:3vh;height:3vh;position: relative;background:#fff;display:flex;justify-content: center;align-items: center;">
                                <img :src="item.icon" style="max-width:3vh;max-height:3vh;" />
                            </div>
                <span style="font-size: 18px">{{item.name}}</span>
              </div>
              <div style="font-size: 18px">{{item.val}}{{item.unit}}</div>
              <div style="font-size: 18px">{{item.createDate}}</div>
            </div>
          </div>
        </div> -->
          <div class="content-right-4">
            <p
              class="title"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <span>特种设备人员操作列表</span><span class="button">更多</span>
            </p>
            <el-table
              :data="tableData"
              height="33.5vh"
            >
              <el-table-column
                prop="index"
                label="序号"
                width="80"
              > </el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
              > </el-table-column>
              <el-table-column
                prop="certificateNumber"
                label="证件编号"
              >
              </el-table-column>
              <el-table-column
                prop="certificatePhoto"
                label="查看证书"
              >
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.certificatePhoto != ''"
                    style="width: 6vh; height: 6vh"
                    :src="scope.row.certificatePhoto"
                    :preview-src-list="scope.row.photoList"
                  ></el-image>
                  <div
                    v-else
                    class="no-photo"
                    style="display: inline-block"
                  >
                    <span style="display: block">暂无</span>
                    <span style="display: block">图片</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作记录">
                <template slot-scope="scope">
                  <div style="
                      height: 100px;
                      display: flex;
                      align-content: center;
                      align-items: center;
                      justify-content: center;
                    ">
                    <el-image
                      v-if="scope.row.photoFile != ''"
                      style="width: 6vh; height: 6vh"
                      :src="scope.row.photoFile"
                      :preview-src-list="scope.row.photoList"
                    ></el-image>
                    <span style="margin-left: 1vh">时间：{{ scope.row.clockTime }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="content2"
      v-else
    >
      <div class="content-left">
        <div class="content-left-top">
          <div style="font-size: 18px; display: flex; align-items: center">
            <img
              style="display: flex; align-items: flex-end; cursor: pointer"
              src="../../../assets/image/back.png"
              @click="$router.go(-1)"
              alt=""
            /><span style="
                width: 8vw;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                font-size: 16px;
              ">{{ towerName }}</span>
          </div>
          <div>
            <span
              class="button"
              style="margin-right: 1vw"
              @click="entDatas"
            >参数设置</span>
            <span
              class="button"
              @click="handleDelete"
            >删除</span>
          </div>
        </div>
        <div class="content-left-main">
          <div style="height: 180px">
            <img
              src="../../../assets/image/tdjc.png"
              style="height: 100%"
            />
          </div>
          <div class="content-left-1">
            <div>
              <p style="margin-bottom: 10px">{{ towerHeight || 0 }}m</p>
              <p style="font-size: 16px">塔身高度</p>
            </div>
            <div>
              <p style="margin-bottom: 10px">{{ towerArmLength || 0 }}m</p>
              <p style="font-size: 16px">起重臂长</p>
            </div>
          </div>
          <div class="content-left-2">
            <div>吊钩高度：{{ valData.hight }}m</div>
            <div>小车幅度：{{ valData.radius }}m</div>
            <div>大臂回转：{{ valData.angle }}°</div>
            <div>吊起重量：{{ valData.loadweightr }}T</div>
            <div>起重力矩：{{ valData.lijupercent }}%</div>
            <div>姿态倾角：{{ valData.fall }}°</div>
            <div>塔顶风速：{{ valData.windspeed }}m/s</div>
            <p style="font-size: 14px; color: #909399">
              更新时间：{{ allPart.updateDate }}
            </p>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="content-right-top">
          <div class="box2">
            <div class="box-title">大臂回转角度监测</div>
            <div class="box-cont">
              <div class="real-clock">
                <div
                  class="real-clock-con"
                  id="wrap"
                >
                  <ul id="list"></ul>
                  <div class="icon"></div>
                  <div
                    id="clockLine"
                    :style="{
                      '-webkit-transform': 'rotate(' + allPart.angle + 'deg)',
                    }"
                  ></div>
                  <div class="num0">0</div>
                  <div class="num90">90</div>
                  <div class="num180">180</div>
                  <div class="num270">270</div>
                </div>
              </div>
            </div>
            <p class="wenzi">当前角度</p>
          </div>
          <div class="box3">
            <div class="box-title">实时预警</div>
            <div class="box-cont">
              <div style="width: 100%;height: 100%;padding: 1vh 1.5vw;display: flex;align-items: center;align-content: center;justify-content: center;justify-items: center;flex-wrap: wrap;overflow: hidden;margin-top: 12%;
                ">
                <img
                  :src="warn.icon"
                  style="width: 23vh; position: relative"
                />
                <template v-if="warn.list.length > 0">
                  <p
                    v-for="(item, index) in warn.list"
                    :key="index"
                    style="width: 100%; margin-top: 1vh; color: red"
                  >
                    {{ item }}
                  </p>
                </template>
                <template v-else>
                  <p style="width: 100%; margin-top: 1vh">暂无预警</p>
                </template>
              </div>
            </div>
          </div>
          <div class="content-right-3">
            <p
              class="title"
              style="
                display: flex;
                
                align-items: center;
              "
            >
              <span>预警记录</span>
              <span
                @click="toMore"
                class="button"
                style="margin-left: 9.0417vw;"
              >更多</span>
              <span
                @click="addShow"
                class="button"
                style="margin-left: .5208vw;"
              >设置</span>
            </p>
            <div style="height: 45vh;padding: 18px 8px;overflow: auto;padding-bottom: 0;">
              <div
                class="record-list"
                v-for="(item, index) in warnList"
                :key="index"
              >
                <div style="display: flex; align-items: center">
                  <div style="
                      margin-right: 3px;
                      width: 3vh;
                      height: 3vh;
                      position: relative;
                      background: #fff;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <img
                      :src="httpCtx + item.icon"
                      style="max-width: 3vh; max-height: 3vh"
                    />
                  </div>
                  <span style="font-size: 14px">{{ item.name }}</span>
                </div>
                <div style="font-size: 14px">{{ item.value }} {{ item.unit }}</div>
                <div style="font-size: 14px">{{ item.createDate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="video"
          v-show="row.connectedStatus === '在线' && row.camera !== null"
        >
          <!-- <div class="video"> -->
          <div
            class="btn"
            id="btn"
            @click="enterDg"
          >操作</div>
          <div
            id="video-container"
            class="box-video"
            style="width: 100%"
          ></div>
          <!-- <div class="box-right1">
                <div class="itemR" style="height:100%;">
                    <p class="item_title">操作管理</p>
                    <div class="item_content">
                        <div class="itemR_first">
                            <div class="itemR_first_t">
                                <div class="l_left"></div><span>回放</span><div class="l_right"></div>
                            </div>
                            <p class="itemR_first_n">
                                <span class="itemR_first_n_name">开始时间：</span>
                                <el-date-picker
                                    v-model="starttime"
                                    type="datetime"
                                    placeholder="选择开始时间"
                                    align="right"
                                    value-format="yyyyMMddHHmmss"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </p>
                            <p class="itemR_first_n">
                                <span class="itemR_first_n_name" >结束时间：</span>
                                <el-date-picker
                                    v-model="endtime"
                                    type="datetime"
                                    placeholder="选择结束时间"
                                    align="right"
                                    value-format="yyyyMMddHHmmss"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </p>
                            <div class="btns">
                                <div class="layui-btn-container">
                                <el-button type="primary" @click="clickRecordSearch">播放</el-button>
                            </div>
                            <div class="layui-btn-container">
                                <el-button type="primary" v-if="!isLu" @click="startLu">边播边录</el-button>
                                <el-button type="primary" style="margin-left:5px" v-if="isLu" disabled>{{transTime(recTime)}}</el-button>
                                <el-button type="primary" v-if="isLu" @click="stopLu">结束录像</el-button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="content-right-bottom">
          <div class="content-right-4">
            <p
              class="title"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <span>特种设备人员操作列表</span><span class="button">更多</span>
            </p>
            <el-table
              :data="tableData"
              height="33.5vh"
            >
              <el-table-column
                prop="index"
                label="序号"
                width="80"
              > </el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
              > </el-table-column>
              <el-table-column
                prop="certificateNumber"
                label="证件编号"
              >
              </el-table-column>
              <el-table-column
                prop="certificatePhoto"
                label="查看证书"
              >
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.certificatePhoto != ''"
                    style="width: 6vh; height: 6vh"
                    :src="scope.row.certificatePhoto"
                    :preview-src-list="scope.row.photoList"
                  ></el-image>
                  <div
                    v-else
                    class="no-photo"
                    style="display: inline-block"
                  >
                    <span style="display: block">暂无</span>
                    <span style="display: block">图片</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作记录">
                <template slot-scope="scope">
                  <div style="height: 100px;display: flex;align-content: center;align-items: center;justify-content: center;
                    ">
                    <el-image
                      v-if="scope.row.photoFile != ''"
                      style="width: 6vh; height: 6vh"
                      :src="scope.row.photoFile"
                      :preview-src-list="scope.row.photoList"
                    ></el-image>
                    <span style="margin-left: 1vh">时间：{{ scope.row.clockTime }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 预警设置窗口 -->
    <el-dialog
      title="预警设置"
      :visible.sync="addFormVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="35%"
      :close-on-click-modal="false"
      @close="noShow"
    >
      <el-row>
        <el-col :span="24">
          <el-form label-width="80px">
            <el-row>
              <el-col :span="11"><el-form-item label="吊钩高度">
                  <el-input
                    placeholder="请输入预警值"
                    v-model="addfrom.heightWarning"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; m</p>
              </el-col>
              <el-col :span="9">
                <el-form-item style="margin-left: -2.6042vw;">
                  <el-input
                    placeholder="报警值"
                    v-model="addfrom.heightAlarm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; m</p>
              </el-col>
            </el-row>
            <!-- === -->
            <el-row>
              <el-col :span="11"><el-form-item label="小车幅度">
                  <el-input
                    placeholder="请输入预警值"
                    v-model="addfrom.radiusWarning"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; m</p>
              </el-col>
              <el-col :span="9">
                <el-form-item style="margin-left: -2.6042vw;">
                  <el-input
                    placeholder="报警值"
                    v-model="addfrom.radiusAlarm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; m</p>
              </el-col>
            </el-row>
            <!-- === -->
            <el-row>
              <el-col :span="11"><el-form-item label="大臂回转">
                  <el-input
                    placeholder="请输入预警值"
                    v-model="addfrom.angleWarning"
                  >

                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; °</p>
              </el-col>
              <el-col :span="9">
                <el-form-item style="margin-left: -2.6042vw;">
                  <el-input
                    placeholder="报警值"
                    v-model="addfrom.angleAlarm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; °</p>
              </el-col>

            </el-row>
            <!-- === -->
            <el-row>
              <el-col :span="11"><el-form-item label="起重力矩">
                  <el-input
                    placeholder="请输入预警值"
                    v-model="addfrom.lijupercentWarning"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; %</p>
              </el-col>
              <el-col :span="9">
                <el-form-item style="margin-left: -2.6042vw;">
                  <el-input
                    placeholder="报警值"
                    v-model="addfrom.lijupercentAlarm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; %</p>
              </el-col>
            </el-row>
            <!-- === -->
            <el-row>
              <el-col :span="11"><el-form-item label="吊起重量">
                  <el-input
                    placeholder="请输入预警值"
                    v-model="addfrom.loadweightrWarning"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; T</p>
              </el-col>
              <el-col :span="9">
                <el-form-item style="margin-left: -2.6042vw;">
                  <el-input
                    placeholder="报警值"
                    v-model="addfrom.loadweightrAlarm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; T</p>
              </el-col>
            </el-row>
            <!-- === -->
            <el-row>
              <el-col :span="11"><el-form-item label="姿态倾角">
                  <el-input
                    placeholder="请输入预警值 "
                    v-model="addfrom.fallWarning"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; °</p>
              </el-col>
              <el-col :span="9">
                <el-form-item style="margin-left: -2.6042vw;">
                  <el-input
                    placeholder="报警值"
                    v-model="addfrom.fallAlarm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; °</p>
              </el-col>
            </el-row>
            <!-- === -->
            <el-row>
              <el-col :span="11"><el-form-item label="塔顶风速">
                  <el-input
                    placeholder="请输入预警值"
                    v-model="addfrom.windspeedWarning"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp; m/s</p>
              </el-col>
              <el-col :span="9">
                <el-form-item style="margin-left: -2.6042vw;">
                  <el-input
                    placeholder="报警值"
                    v-model="addfrom.windspeedAlarm"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <p style="line-height:2.0833vw; font-size: 12px; color: #909399;">&nbsp;m/s</p>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="sumbitAddRow('addForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
import EZUIKit from 'ezuikit-js'
export default {
  name: 'towerRecord',
  data () {
    return {
      addfrom: {
        //机器序列号
        id: '',
        //项目id
        projectId: util.session.get('groupId'),
        //设备名称
        name: '',
        //吊钩高度预警
        heightWarning: '',
        //吊钩高度报警
        heightAlarm: '',
        //小车幅度预警
        radiusWarning: '',
        //小车幅度报警
        radiusAlarm: '',
        //大臂回转预警
        angleWarning: '',
        //大臂回转报警
        angleAlarm: '',
        //吊起重量预警
        loadweightrWarning: '',
        //吊起重量报警
        loadweightrAlarm: '',
        //力矩百分比预警
        lijupercentWarning: '',
        //力矩百分比报警
        lijupercentAlarm: '',
        //姿态倾角预警
        fallWarning: "",
        //姿态倾角报警
        fallAlarm: "",
        //塔顶风速预警
        windspeedWarning: "",
        //塔顶风速报警
        windspeedAlarm: "",
      },
      addFormVisible: false,
      httpCtx: base.httpCtx,
      towerArmLength: '',
      towerHeight: '',
      towerName: '',
      groupId: '',
      //实时数据列表
      valData: {
        radius: 0, //幅度
        lijupercent: 0, //力矩
        ratedWeight: 0, //额定吊重
        loadweightr: 0, //起吊吊重
        hight: 0, //高度
        fall: 0, //前倾角
        angle: 0, //大臂回转
        windspeed: 0, //风速
      },
      towerId: '', // 塔吊id
      allPart: {}, //当前塔吊信息
      //预警
      warn: {
        icon: require('../../../assets/image/icon/warn.png'),
        list: [],
      },
      deviceId: '',
      warnList: [], //列表
      row: {},
      starttime: '',
      endtime: '',
      serial: '',
      channel: '',
      ysToken: '', //萤石云token
      type: '',
      player: null,
      recTime: 0, //录像时间
      isLu: false,
      //时间快捷键
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick (picker) {
              picker.$emit('pick', new Date())
            },
          },
          {
            text: '昨天',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            },
          },
          {
            text: '一周前',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            },
          },
        ],
      },
      tableData: [],
      towerlist: [],
      teamsId: ''
    }
  },
  created () {
    this.groupId = util.session.get('groupId')
    this.towerId = this.$route.query.towerId
    this.deviceId = this.$route.query.deviceId
    this.addfrom.id = this.$route.query.deviceId
    this.addfrom.name = this.$route.query.name
    this.getRealInfo() // 获取塔吊数据

  },
  mounted () {
    this.getTowerList()
  },
  updated () {
    let that = this
    const mapFrame = that.$refs.mainIframe
    // console.log(mapFrame);
    if (mapFrame.attachEvent) {
      mapFrame.attachEvent('onload', function () {
        const iframeWin = mapFrame.contentWindow
        iframeWin.postMessage(that.towerName)
      })
    } else {
      mapFrame.onload = function () {
        const iframeWin = mapFrame.contentWindow
        // console.log(that.towerName);
        iframeWin.postMessage(that.towerName)
      }
    }
  },
  methods: {
    async addShow () {
      const data = await myHttp.findWarningConfig({
        id: this.$route.query.deviceId,
        projectId: util.session.get('groupId')
      })
      console.log('data======>', data);
      this.addfrom = data.data.data || {
        //机器序列号
        id: '',
        //项目id
        projectId: util.session.get('groupId'),
        //设备名称
        name: '',
        //吊钩高度预警
        heightWarning: '',
        //吊钩高度报警
        heightAlarm: '',
        //小车幅度预警
        radiusWarning: '',
        //小车幅度报警
        radiusAlarm: '',
        //大臂回转预警
        angleWarning: '',
        //大臂回转报警
        angleAlarm: '',
        //吊起重量预警
        loadweightrWarning: '',
        //吊起重量报警
        loadweightrAlarm: '',
        //力矩百分比预警
        lijupercentWarning: '',
        //力矩百分比报警
        lijupercentAlarm: '',
        //姿态倾角预警
        fallWarning: "",
        //姿态倾角报警
        fallAlarm: "",
        //塔顶风速预警
        windspeedWarning: "",
        //塔顶风速报警
        windspeedAlarm: "",
      },
        this.addfrom.id = this.$route.query.deviceId
      this.addfrom.name = this.$route.query.name
      this.addfrom.projectId = util.session.get('groupId'),
        this.addFormVisible = true
    },
    noShow () {
      this.addfrom = {
        //机器序列号
        id: '',
        //项目id
        projectId: util.session.get('groupId'),
        //设备名称
        name: '',
        //吊钩高度预警
        heightWarning: '',
        //吊钩高度报警
        heightAlarm: '',
        //小车幅度预警
        radiusWarning: '',
        //小车幅度报警
        radiusAlarm: '',
        //大臂回转预警
        angleWarning: '',
        //大臂回转报警
        angleAlarm: '',
        //吊起重量预警
        loadweightrWarning: '',
        //吊起重量报警
        loadweightrAlarm: '',
        //力矩百分比预警
        lijupercentWarning: '',
        //力矩百分比报警
        lijupercentAlarm: '',
        //姿态倾角预警
        fallWarning: "",
        //姿态倾角报警
        fallAlarm: "",
        //塔顶风速预警
        windspeedWarning: "",
        //塔顶风速报警
        windspeedAlarm: "",
      }
    },
    async sumbitAddRow () {
      this.addfrom.id = this.$route.query.deviceId
      this.addfrom.name = this.$route.query.name
      this.addfrom.projectId = util.session.get('groupId')
      try {

        const res = await myHttp.addWarningConfig(this.addfrom)
        console.log(res);
        this.$message.success('设置成功')
        this.addFormVisible = false
      }
      catch (erro) {
        this.$message.error(erro)
      }
    },
    //获取人员操作记录
    getPerson () {
      var that = this
      myHttp
        .getTzListByTeamsId({
          projectId: this.groupId,
          teamsId: this.teamsId,
          daysss: util.myTime.getCurTime(),
          status: '1',
          attendanceSn: this.deviceId,
        })
        .then(function (resp) {
          // console.log(resp);
          if (resp.data.code == '200') {
            var list = resp.data.data.attendList || []
            for (var i = 0; i < list.length; i++) {
              list[i].certificatePhoto =
                list[i].certificatePhoto && list[i].certificatePhoto != ''
                  ? base.httpCtx + list[i].certificatePhoto
                  : ''
              list[i].photoList = []
              if (list[i].certificatePhoto != '') {
                list[i].photoList.push(list[i].certificatePhoto)
              }
              list[i].photoFile =
                list[i].photoFile && '' != list[i].photoFile
                  ? base.httpCtx + list[i].photoFile
                  : ''
              if (list[i].photoFile != '') {
                list[i].photoList.push(list[i].photoFile)
              }
              list[i].index = i + 1
            }
            that.tableData = list
          }
        })
    },
    //获取班组id
    getTeamId (id) {
      var list = this.towerlist
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].deviceId) {
          result = list[i].teamsId
        }
      }
      return result
    },
    //获取sn
    getSn (id) {
      var list = this.towerlist
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].deviceId) {
          result = list[i].attendanceSn
        }
      }
      return result
    },

    //获取塔吊设备
    getTowerList () {
      var that = this
      myHttp
        .getTowerListByPage({
          projectId: this.groupId,
        })
        .then(function (resp) {
          // console.log(resp,'123123')
          if (resp.data.code == '200') {
            var list = resp.data.data.towerList || []
            for (var i = 0; i < list.length; i++) {
              if (list[i].machType == '3') {
                list[i].online =
                  list[i].connectedStatus && '' != list[i].connectedStatus
                    ? list[i].connectedStatus
                    : '离线'
              } else {
                if (list[i].status == '0') {
                  list[i].online = '离线'
                } else if (list[i].status == '1') {
                  list[i].online = '在线'
                } else {
                  list[i].online = '异常'
                }
              }
            }
            that.towerlist = list
          }
        })
    },
    //回看
    clickRecordSearch () {
      this.player.stop()
      document.getElementById('video-container').innerHTML = ''
      if (
        (!this.starttime || this.starttime == '') &&
        (!this.endtime || this.endtime == '')
      ) {
        this.showVideo()
      } else {
        var ezurl =
          'ezopen://open.ys7.com/' +
          this.serial +
          '/' +
          this.channel +
          '.hd.rec?begin=' +
          this.starttime +
          '&end=' +
          this.endtime
        this.player = new EZUIKit.EZUIKitPlayer({
          id: 'video-container', // 视频容器ID
          accessToken: this.ysToken,
          url: ezurl,
        })
      }
    },
    enterDg () {
      let that = this
      let a = JSON.stringify(that.row)
      this.$router.push({
        name: 'towerMonitor1',
        params: {
          row: a,
        },
      })
    },
    //展示列表
    toMore () {
      if (this.deviceId) {
        this.$router.push({ path: '/towerWarn/' + this.deviceId })
      } else {
        this.$message.error('暂无更多')
      }
    },
    initWebSocket () {
      if (this.websock) {
        this.websock.close()
      }
      var that = this
      //初始化weosocket
      if ('WebSocket' in window) {
        var url = ''
        if (document.location.protocol == 'https:') {
          url = base.httpsWs + '/webSocketEquip/' + this.deviceId //wss地址;
        } else {
          url = base.httpWs + '/webSocketEquip/' + this.deviceId //ws地址;
        }
        // var url=base.httpWs+"/webSocketEquip/"+this.groupId;//ws地址;
        // console.log(url);
        this.websocket = new WebSocket(url)
      } else {
        alert('Not support websocket')
      }
      //连接发生错误的回调方法
      this.websocket.onerror = function () {
        //setMessageInnerHTML("error");
      }
      //连接成功建立的回调方法
      this.websocket.onopen = function (event) {
        //$("#serverinfo").hide();
        that.errorFlag = false
        that.timeOutObj = null
      }
      //接收到消息的回调方法
      this.websocket.onmessage = function (event) {
        console.log(event)
        if (event.data == '连接成功') return
        var x = JSON.parse(event.data)

        if (x.flag == 30) {
          console.log(x)
          const list = []
          const data = x.towerLog
          //  if(data.loadweightr && data.loadweightrTime){
          //       var obj1 = {
          //           icon : require('../../../assets/image/icon/gd.png'),
          //           name : '高度预警',
          //           val : parseFloat(data.loadweightr).toFixed(2)||0,
          //           unit : '米',
          //           createDate:util.myTime.formatTime(data.loadweightrTime, 'YYYY-MM-dd HH:mm:ss')||''
          //       }
          //       list.push(obj1)
          //   }
          //   if(data.fall && data.fallTime){
          //       var obj2 = {
          //           icon : require('../../../assets/image/icon/qs.png'),
          //           name : '倾斜报警',
          //           val : parseFloat(data.fall).toFixed(2)||0,
          //           unit : '度',
          //           createDate:util.myTime.formatTime(data.fallTime , 'YYYY-MM-dd HH:mm:ss')||''
          //       }
          //       list.push(obj2)
          //   }
          //   if(data.lijupercent && data.lijupercentTime){
          //       var obj3 = {
          //           icon : require('../../../assets/image/icon/lj.png'),
          //           name : '力矩报警',
          //           val : parseFloat(data.lijupercent).toFixed(2)||0,
          //           unit : '百分比',
          //           createDate:util.myTime.formatTime(data.lijupercentTime , 'YYYY-MM-dd HH:mm:ss')||''
          //       }
          //       list.push(obj3)
          //   }
          //   if(data.radius && data.radiusTime){
          //       var obj4 = {
          //           icon : require('../../../assets/image/icon/fd.png'),
          //           name : '幅度报警',
          //           val : parseFloat(data.radius).toFixed(2)||0,
          //           unit : '米',
          //           createDate:util.myTime.formatTime(data.radiusTime , 'YYYY-MM-dd HH:mm:ss')||''
          //       }
          //       list.push(obj4)
          //   }
          //   if(data.windspeed && data.windspeedTime){
          //       var obj5 = {
          //           icon : require('../../../assets/image/icon/fs.png'),
          //           name : '风速报警',
          //           val : parseFloat(data.windspeed).toFixed(2)||0,
          //           unit : '米每秒',
          //           createDate:util.myTime.formatTime(data.windspeedTime , 'YYYY-MM-dd HH:mm:ss')||''
          //       }
          //       list.push(obj5)
          //   }
          //   if(data.hight && data.hightTime){
          //       var obj6 = {
          //           icon : require('../../../assets/image/icon/gd.png'),
          //           name : '吊钩高度报警',
          //           val : parseFloat(data.hight).toFixed(2)||0,
          //           unit : '米',
          //           createDate:util.myTime.formatTime(data.hightTime , 'YYYY-MM-dd HH:mm:ss')||''
          //       }
          //       list.push(obj6)
          //   }
          //   if(data.angle && data.angleTime){
          //       var obj5 = {
          //           icon : require('../../../assets/image/icon/hz.png'),
          //           name : '回转报警',
          //           val : parseFloat(data.angle).toFixed(2)||0,
          //           unit : '度',
          //           createDate:util.myTime.formatTime(data.angleTime , 'YYYY-MM-dd HH:mm:ss')||''
          //       }
          //       list.push(obj5)
          //   }

          // that.warnList = list
          data.forEach((item) => {
            item.createDate =
              util.myTime.formatTime(item.createDate, 'YYYY-MM-dd HH:mm:ss') ||
              ''
          })
          that.warnList = data
        } else {
          if (x.tower.deviceId == that.deviceId) {
            var data = x.tower
            that.angle = data.angle && '' != data.angle ? data.angle : 0
            data.updateDate = util.myTime.formatTime(data.updateDate || new Date().getTime(), 'YYYY-MM-dd HH:mm:ss')
            that.allPart = data
            // console.log('转角：'+that.allPart.angle+'====高度='+that.allPart.hight)
            // that.valData[0].val1 = data && data.radius &&data.radius!=''?parseFloat(data.radius).toFixed(2)+'m':'0m'
            // that.valData[0].val2 = data && data.lijupercent &&data.lijupercent!=''?parseFloat(data.lijupercent).toFixed(1)+'%':'0%'
            // that.valData[1].val1 = data && data.ratedWeight &&data.ratedWeight!=''?parseFloat(data.ratedWeight).toFixed(0)+'T':'0T'
            // that.valData[1].val2 = data && data.loadweightr &&data.loadweightr!=''?parseFloat(data.loadweightr).toFixed(2)+'T':'0T'
            // that.valData[2].val1 = data && data.hight &&data.hight!=''?parseFloat(data.hight).toFixed(2)+'m':'0m'
            // that.valData[2].val2 = data && data.fall &&data.fall!=''?parseFloat(data.fall).toFixed(2)+'°':'0°'
            for (var i in that.valData) {
              that.valData[i] = data[i] || 0
            }

            // console.log(that.valData);
            if (data.status == '3' || data.status == '2') {
              that.warn.icon = require('../../../assets/image/icon/warning.gif')
              that.warn.list = [data.reasonStr]
              setTimeout(() => {
                that.warn.icon = require('../../../assets/image/icon/warn.png')
                that.warn.list = []
              }, 30000)
            }
          }
        }
      }
      //连接关闭的回调方法
      this.websocket.onclose = function () {
        this.timeOutObj = setTimeout(function () {
          that.initWebSocket()
        }, 60000)
        // $("#serverinfo").show();
        that.errorFlag = true
      }
      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = function () {
        that.websocket.close()
      }
    },
    //获取数据  recentWarningList
    // getWarnLast(){
    //     var that = this
    //     myHttp.recentWarning({
    //         projectId:util.session.get('groupId'),
    //         deviceId:this.deviceId
    //     }).then(function(resp){
    //         console.log(resp);
    //         if(resp.data.code=='200'){
    //             var list = []
    //             var data = resp.data.data
    //             if(data.loadweightr && data.loadweightrTime){
    //                 var obj1 = {
    //                     icon : require('../../../assets/image/icon/gd.png'),
    //                     name : '高度预警',
    //                     val : parseFloat(data.loadweightr).toFixed(2)||0,
    //                     unit : '米',
    //                     createDate:data.loadweightrTime||''
    //                 }
    //                 list.push(obj1)
    //             }
    //             if(data.fall && data.fallTime){
    //                 var obj2 = {
    //                     icon : require('../../../assets/image/icon/qs.png'),
    //                     name : '倾斜报警',
    //                     val : parseFloat(data.fall).toFixed(2)||0,
    //                     unit : '度',
    //                     createDate:data.fallTime||''
    //                 }
    //                 list.push(obj2)
    //             }
    //             if(data.lijupercent && data.lijupercentTime){
    //                 var obj3 = {
    //                     icon : require('../../../assets/image/icon/lj.png'),
    //                     name : '力矩报警',
    //                     val : parseFloat(data.lijupercent).toFixed(2)||0,
    //                     unit : '百分比',
    //                     createDate:data.lijupercentTime||''
    //                 }
    //                 list.push(obj3)
    //             }
    //             if(data.radius && data.radiusTime){
    //                 var obj4 = {
    //                     icon : require('../../../assets/image/icon/fd.png'),
    //                     name : '幅度报警',
    //                     val : parseFloat(data.radius).toFixed(2)||0,
    //                     unit : '米',
    //                     createDate:data.radiusTime||''
    //                 }
    //                 list.push(obj4)
    //             }
    //             if(data.windspeed && data.windspeedTime){
    //                 var obj5 = {
    //                     icon : require('../../../assets/image/icon/fs.png'),
    //                     name : '风速报警',
    //                     val : parseFloat(data.windspeed).toFixed(2)||0,
    //                     unit : '米每秒',
    //                     createDate:data.windspeedTime||''
    //                 }
    //                 list.push(obj5)
    //             }
    //             if(data.hight && data.hightTime){
    //                 var obj6 = {
    //                     icon : require('../../../assets/image/icon/gd.png'),
    //                     name : '吊钩高度报警',
    //                     val : parseFloat(data.hight).toFixed(2)||0,
    //                     unit : '米',
    //                     createDate:data.hightTime||''
    //                 }
    //                 list.push(obj6)
    //             }
    //             if(data.angle && data.angleTime){
    //                 var obj5 = {
    //                     icon : require('../../../assets/image/icon/hz.png'),
    //                     name : '回转报警',
    //                     val : parseFloat(data.angle).toFixed(2)||0,
    //                     unit : '度',
    //                     createDate:data.angleTime||''
    //                 }
    //                 list.push(obj5)
    //             }
    //             that.warnList = list

    //         }
    //     })
    // },

    getWarnLast () {
      myHttp
        .recentWarningList({
          deviceId: this.deviceId,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code === 200) {
            this.warnList = res.data.data.warningVos
          }
        })
    },

    // 删除数据
    handleDelete () {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        myHttp
          .towerDeleteInfo({
            id: that.$route.query.towerId,
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.$router.go(-1)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
    // 跳转数据设置
    entDatas () {
      this.$router.push({
        path: '/basicDataSetting',
        query: {
          id: this.$route.query.deviceId,
        },
      })
    },
    // 获取塔吊数据
    getRealInfo () {
      var that = this
      myHttp
        .getTowerInfoByPage({
          id: this.towerId,
          v: new Date().getTime(),
        })
        .then(function (resp) {
          // that.machType = resp.data.data.tower.machType
          // console.log(resp,'999')
          if (resp.data.code == '200') {
            var data = resp.data.data.tower || {}
            that.row = data
            // console.log(that.row,'7777777777')
            that.towerName = data.name
            data.angle = data.angle && '' != data.angle ? data.angle : 0
            data.updateDate = util.myTime.formatTime(
              data.updateDate,
              'yyyy-MM-dd HH:mm:ss',
            )
            that.teamsId = data.teamsId
            that.allPart = data
            console.log(JSON.parse(data.baseSetting))
            try {
              that.towerArmLength = JSON.parse(
                data.baseSetting
              ).rangeSettingBean.towerArmLength
              that.towerHeight = JSON.parse(
                data.baseSetting
              ).heightSettingBean.towerHeight
            } catch (error) {
              console.log(error)
            }

            // that.valData[0].val1 = data && data.radius &&data.radius!=''?parseFloat(data.radius).toFixed(2)+'m':'0m'
            // that.valData[0].val2 = data && data.lijupercent &&data.lijupercent!=''?parseFloat(data.lijupercent).toFixed(1)+'%':'0%'
            // that.valData[1].val1 = data && data.ratedWeight &&data.ratedWeight!=''?parseFloat(data.ratedWeight).toFixed(0)+'T':'0T'
            // that.valData[1].val2 = data && data.loadweightr &&data.loadweightr!=''?parseFloat(data.loadweightr).toFixed(2)+'T':'0T'
            // that.valData[2].val1 = data && data.hight &&data.hight!=''?parseFloat(data.hight).toFixed(2)+'m':'0m'
            // that.valData[2].val2 = data && data.fall &&data.fall!=''?parseFloat(data.fall).toFixed(2)+'°':'0°'
            for (var i in that.valData) {
              that.valData[i] = data[i] || 0
            }
            that.cameraData = data.camera || {}
            if (data.camera) {
              that.shwoVideo(data.camera)
            }
          }
          // that.timeRefrsh = setTimeout(function(){
          //     that.getRealInfo()
          // },60000)
          that.initWebSocket()
          that.getWarnLast()
          that.getPerson()
        })
    },
    //渲染监控
    shwoVideo (obj) {
      this.serial = obj.serial
      this.channel = obj.channelNo
      this.type = obj.type
      this.getYsToken()
    },
    //获取token
    getYsToken () {
      var that = this
      myHttp
        .getYsToken({
          projectId: this.groupId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.ysToken = resp.data.data.accessToken || ''
            that.showVideo()
          }
        })
    },
    //展示监控
    showVideo () {
      // var ezurl = "ezopen://open.ys7.com/"+this.serial+"/"+this.channel+".hd.live";
      var ezurl =
        'ezopen://open.ys7.com/' + this.serial + '/' + this.channel + '.live'
      this.player = new EZUIKit.EZUIKitPlayer({
        id: 'video-container', // 视频容器ID
        accessToken: this.ysToken,
        url: ezurl,
        plugin: ['talk'],
        handleSuccess: function () {
          console.log('播放成功')
        },
        handleError: function (e) {
          console.log('播放失败：')
          console.error(e)
        },
        openSoundCallBack: function (e) {
          console.log('声音开启：')
          console.log(e)
        },
        closeSoundCallBack: function (e) {
          console.log('声音关闭：')
          console.log(e)
        },
        startSaveCallBack (e) {
          console.log('开启本地录像：')
          console.log(e)
        },
        stopSaveCallBack (e) {
          console.log('结束本地录像：')
          console.log(e)
        },
      })
    },
    //时间转换
    transTime (val) {
      return util.common.s_to_hs(val)
    },
    //本地录像 -开始
    startLu () {
      this.isLu = true
      this.player.startSave()
      this.recTime = 0
      this.luDing = window.setInterval(() => {
        this.recTime++
      }, 1000)
    },
    //本地录像 -结束
    stopLu () {
      this.isLu = false
      this.player.stopSave()
      window.clearInterval(this.luDing)
    },
    tableHeaderStyle ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return 'background: #ECF0F5'
      }
    },
  },
}
</script>

<style scoped>
@import '../../../assets/css/clock.css';

.content>>>.cell {
  font-size: 14px;
}

.content>>>.el-table td.el-table__cell div {
  font-size: 14px;
}

.button {
  display: inline-block;
  width: 68px;
  height: 26px;
  line-height: 26px;
  border-radius: 6px;
  background: #fdfefe;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  cursor: pointer;
  text-align: center;
  font-size: 14px;
}

.title {
  height: 60px;
  padding: 0 18px;
  line-height: 60px;
  text-align: left;
  border-bottom: 2px solid #e7e7e7;
  font-size: 16px;
}

.content {
  height: 100%;
}

.content2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.content-left {
  width: 23%;
  height: 100%;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-right: 8px;
  overflow: auto;
}

.content-left-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 18px;
  border-bottom: 2px solid #e7e7e7;
}

.content-left-1 {
  display: flex;
  justify-content: space-between;
  padding: 0 2vw;
  margin-bottom: 2vh;
}

.content-left-1>div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content-left-2>div {
  width: 12vw;
  height: 50px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin: 0 auto;
  margin-bottom: 17px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
}

.content-right {
  flex: 1;
  overflow: auto;
}

.content-right::-webkit-scrollbar {
  width: 2px;
}

.content-right-top {
  height: 54vh;
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1vh;
}

.content-right-1 {
  width: 62%;
  height: 100%;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}

.content-right-2 {
  width: 36%;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}

.content-right-bottom {
  display: flex;
  justify-content: space-between;
  height: 33.6vh;
}

.content-right-3 {
  width: 49%;
  height: 100%;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-right: 8px;
}

.record-list {
  height: 48px;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: #d21b1b;
  padding: 0 16px;
}

.content-right-4 {
  /* width: 49%; */
  /* flex: 1; */
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}

.box2 {
  width: 24vw;
  background: #ffffff;
  box-shadow: 2px 3px 7px 0px rgba(105, 159, 204, 0.5);
  border-radius: 6px;
  margin-right: 8px;
}

.box3 {
  width: 25vw;
  /* flex: 1; */
  background: #ffffff;
  box-shadow: 2px 3px 7px 0px rgba(105, 159, 204, 0.5);
  border-radius: 6px;
  margin-right: 10px;
}

.box-title {
  height: 6.5vh;
  line-height: 5.5vh;
  border-bottom: 2px solid #e7e7e7;
  padding-left: 6%;
  text-align: start;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  font-size: 16px;
}

.box2>.box-cont {
  height: 38vh;
  display: flex;
  padding-left: 18%;
  /* justify-content: center; */
  align-items: center;
  padding-top: 5vh;
}

.box3>.box-cont>p {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}

.real-clock {
  width: 25%;
  height: 100%;
  position: relative;
  padding: 1vh;
}

#wrap.real-clock-con {
  /* width:100%;
    height:calc( 100% - 3vh ); */
  /* padding:2vh 0; */
  margin-top: 1vh;
  width: 25vh;
  height: 25vh;
}

#clockLine {
  background-color: #6198eeff;

  height: 7vh;
  left: 49.6%;
  top: 19%;
}

.icon {
  background-color: #2f5da7ff;
  left: 45.6%;
  top: 45%;
}

#wrap {
  background-color: #fff;
}

#wrap .num0 {
  top: 4%;
  left: 48.5%;
}

#wrap .num180 {
  top: 89%;
  left: 37%;
}

#wrap .num90 {
  top: 46%;
  right: 5%;
}

#wrap .num270 {
  top: 45%;
  left: 5%;
}

.wenzi {
  text-align: start;
  padding-top: 20px;
  padding-left: 42%;
}

.video {
  margin-top: 1.7vh;
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 44vh;
  margin-bottom: 20px;
}

.box-video {
  width: 70.4%;
  height: 100%;
  background-color: #fff;
  /* border: 10px solid #FFFFFF; */
  box-shadow: 2px 3px 10px 0px rgba(105, 159, 204, 0.5);
  border-radius: 6px;
  position: relative;
}

.video>.btn {
  display: none;
}

.video:hover>.btn {
  display: block;
  cursor: pointer;
  position: absolute;
  right: 20px;
  top: 10px;
  height: 37px;
  width: 93px;
  border: 2px solid rgb(159 212 243);
  color: rgb(8 170 243);
  z-index: 999;
  border-radius: 6px;
  font-size: 20px;
  background-color: #fff;
  opacity: 0.7;
  line-height: 37px;
}

.box-right1 {
  width: 28.2%;
  height: 100%;
  position: relative;
  background: #fafcfeff;
}

.itemR_first,
.itemR_second {
  height: 39vh;
  background: #fff;
  width: 100%;
  padding: 1vh;
  margin-bottom: 10px;
}

.itemR_first_t,
.itemR_second_t {
  height: 3vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 5%;
}

.itemR_first_t div,
.itemR_second_t div {
  width: 30%;
  height: 2px;
  margin-top: 10px;
}

.itemR_first_t span,
.itemR_second_t span {
  padding: 0 20px;
  font-size: 18px;
}

.itemR_first_t div.l_left,
.itemR_second_t div.l_left {
  background: linear-gradient(to right,
      rgba(79, 163, 241, 0),
      rgba(79, 163, 241, 1));
}

.itemR_first_t div.l_right,
.itemR_second_t div.l_right {
  background: linear-gradient(to left,
      rgba(79, 163, 241, 0),
      rgba(79, 163, 241, 1));
}

.itemR_first_n_name {
  display: inline-block;
  width: 6vw;
  text-align: right;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}

.itemR_first_n_val {
  height: 3vh;
  border: 1px solid #ddd;
  padding: 0 0.5vh;
}

.itemR_first_n {
  margin: 5px;
  display: flex;
  align-content: center;
  align-items: center;
  margin-top: 10%;
}

.item_title {
  height: 5vh;
  font-size: 18px;
  padding: 10px;
  background: #fff;
  text-align: start;
  padding-left: 3%;
  border-bottom: 2px solid #e7e7e7;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}

.btns {
  margin-top: 4%;
  display: flex;
  justify-content: space-between;
  padding: 0 24%;
}

.tubiao {
  padding-top: 11px;
  width: 8vw;
}
</style>